import { render, staticRenderFns } from "./LoginMedico.vue?vue&type=template&id=87ee63cc"
import script from "./LoginMedico.vue?vue&type=script&lang=js"
export * from "./LoginMedico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports